let _ = t => t,
  _t;
import FormattedMessage from 'I18n/components/FormattedMessage';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const HIDDEN_ATTACHMENT_TYPES = ['EMAIL_METADATA', 'MENTIONS', 'MESSAGE_HEADER', 'MESSAGE_POSITION_DESCRIPTOR', 'CALL_METADATA', 'INLINE_IMAGES', 'MENTIONS', 'QUICK_REPLIES', 'WHATS_APP_TEMPLATE_METADATA'];
const filteredAttachmentTypes = attachmentTypes => {
  const filtered = attachmentTypes.filter(type => !HIDDEN_ATTACHMENT_TYPES.includes(type));
  return filtered.length > 0 && filtered[0];
};
const AttachmentTypeWrapper = styledWithTheme.div(_t || (_t = _`
  display: inline;
  color: ${0};
`), ({
  theme
}) => theme.color['text-tertiary-default']);
export const AttachmentType = ({
  attachmentTypes,
  repliedTo
}) => {
  const attachmentType = filteredAttachmentTypes(attachmentTypes);
  if (attachmentType === false) return null;
  let formattedMessage;
  switch (attachmentType) {
    case 'CONTACT_ATTACHMENT':
      formattedMessage = repliedTo ? 'svh-workspace-ui-lib.preview-card.attachmentType.contactAttachment.sent' : 'svh-workspace-ui-lib.preview-card.attachmentType.contactAttachment.received';
      break;
    case 'LOCATION':
      formattedMessage = repliedTo ? 'svh-workspace-ui-lib.preview-card.attachmentType.locationAttachment.sent' : 'svh-workspace-ui-lib.preview-card.attachmentType.locationAttachment.received';
      break;
    case 'FILES':
      formattedMessage = repliedTo ? 'svh-workspace-ui-lib.preview-card.attachmentType.fileAttachment.sent' : 'svh-workspace-ui-lib.preview-card.attachmentType.fileAttachment.received';
      break;
    default:
      formattedMessage = repliedTo ? 'svh-workspace-ui-lib.preview-card.attachmentType.default.sent' : 'svh-workspace-ui-lib.preview-card.attachmentType.default.received';
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(AttachmentTypeWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage
      //eslint-disable-next-line conversations/no-dynamic-i18n
      , {
        message: formattedMessage
      })
    })
  );
};
AttachmentType.displayName = 'AttachmentType';